import { API_BASE_URL } from "../../app/utils";
import { authFetch } from "../../app/common";

export const getVouchers = (page, size, search) => {
  const params = new URLSearchParams({
    page: String(page),
    size: String(size),
  });
  const q = search?.trim();
  if (q) params.set("search", q);
  return authFetch(`${API_BASE_URL}/wallet/v1/promo-codes?${params.toString()}`, {
    crossDomain: true,
    method: "GET",
  }).then((res) => res.json());
};

export const getRedeemedVouchers = (code) =>
  authFetch(`${API_BASE_URL}/wallet/v1/vouchers?code=${code}&applied=true`, {
    crossDomain: true,
    method: "GET",
  }).then(res => res.json());

export const createVoucher = (data) =>
  authFetch(`${API_BASE_URL}/wallet/v1/promo-codes`, {
    crossDomain: true,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data)
  }).then(res => res.json());

export const deactivateVoucher = (id, data) =>
  authFetch(`${API_BASE_URL}/wallet/v1/promo-codes/${id}`, {
    crossDomain: true,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      ...data,
      active: false
    })
  }).then(res => res.json());

export const activateVoucher = (id, data) =>
  authFetch(`${API_BASE_URL}/wallet/v1/promo-codes/${id}`, {
    crossDomain: true,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      ...data,
      active: true
    })
  }).then(res => res.json());

export const getVoucherByCode = (code) =>
  authFetch(`${API_BASE_URL}/wallet/v1/promo-codes?code=${code}`, {
    crossDomain: true,
    method: "GET",
  }).then(res => res.json());